import { render, staticRenderFns, recyclableRender, components } from "./collection.vue?vue&type=template&id=b0fe9a78&scoped=true&"
var renderjs
import script from "./collection.vue?vue&type=script&lang=js&"
export * from "./collection.vue?vue&type=script&lang=js&"
import style0 from "./collection.vue?vue&type=style&index=0&id=b0fe9a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fe9a78",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/my-course/collection.vue"
export default component.exports